import { BaseScene } from '@core/scenes/BaseScene';
import { SceneKeys, Palette, GAME_TITLE } from '@core/config/constants';

/**
 * Carga los recursos compartidos y muestra una barra de progreso. Cuando se agreguen
 * assets reales (sprites, audio) se cargan aca con this.load.* dentro de preload().
 */
export class PreloadScene extends BaseScene {
  public constructor() {
    super(SceneKeys.Preload);
  }

  public preload(): void {
    this.renderLoadingUi();
    // Aqui se cargaran los assets compartidos del juego, por ejemplo:
    // this.load.image('logo', 'assets/ui/logo.png');
    // this.load.audio('click', 'assets/sfx/click.mp3');
  }

  public create(): void {
    this.scene.start(SceneKeys.Hub);
  }

  private renderLoadingUi(): void {
    const { width, height } = this.scale;

    this.add
      .text(width / 2, height / 2 - 60, GAME_TITLE, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '48px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    const barWidth = 420;
    const barHeight = 28;
    const barX = (width - barWidth) / 2;
    const barY = height / 2 + 20;

    const border = this.add.graphics();
    border.lineStyle(3, Palette.accent, 1);
    border.strokeRoundedRect(barX, barY, barWidth, barHeight, 14);

    const fill = this.add.graphics();
    this.load.on('progress', (value: number) => {
      fill.clear();
      fill.fillStyle(Palette.primary, 1);
      fill.fillRoundedRect(barX + 4, barY + 4, (barWidth - 8) * value, barHeight - 8, 10);
    });
  }
}
